import { removeEventFromLoadingQueue } from "@/composables/useLoadingQueue";

/**
 * Turns an ApiService rejection into the name of a snippet the customer can act on.
 * ApiService rejects with the raw response body as text, so it has to be parsed here.
 * @param {*} error
 * @param {string} fallback
 * @returns {string}
 */
export function getApiErrorSnippet(error, fallback = "saveFailed") {
  let body = error;

  try {
    body = JSON.parse(error);
  } catch {
    // Not JSON, keep the original value
  }

  // Duplicate project name, the project is named after the export description
  if (body?.errors?.name) {
    return "nameAlreadyTaken";
  }

  // Everything else falls back to a generic snippet on purpose: the backend
  // answers failed project creation with the raw exception message, which can
  // be an internal (e.g. SQL) text the customer should not see
  return fallback;
}

/**
 * Ends a loading event with an error toast instead of a success toast.
 * @param {string} key
 * @param {*} error
 * @param {string} prefix
 */
export function failLoadingEvent(key, error, prefix = "reportExports") {
  // Aborted requests are not failures the customer has to know about
  if (error === "abort") {
    removeEventFromLoadingQueue({ key });

    return;
  }

  removeEventFromLoadingQueue({
    key,
    type: "error",
    prefix,
    name: getApiErrorSnippet(error)
  });
}
